const initialState = {
  isaddRouteFormOpen: false,
  iseditRouteFormOpen: false,
  isaddStopFormOpen: false,
  iseditStopFormOpen: false,
  isaddBusFormOpen: false,
  iseditBusFormOpen: false,
  isAssignFormOpen: false,
  iseditAssignFormOpen: false,
  routeInfo: {
    addRoute: {
      addRouteFormData: {
        bus_id: "",
        route_name: "",
        teacher_id: "",
        teacher_no: "",
        attender_name: "",
        attender_number: "",
        driver_license: "",
        driver_name: "",
        driver_number: ""
      }
    },
    addStop: {
      route_id: '',
      addStopFormData: [
        {
          stop_name: "",
          stop_number: 1,
          pickup_time: "",
          drop_time: "",
          distance_from_school: "",
          lat: "",
          long: ""
        }
      ]
    }
  },
  manageBus: {
    addBus: {
      addBusFormData: {
        bus_no: "",
        registration_number: "",
        registration_date: "",
        seating_capacity: "",
        vendor_name: "",
        vendor_phone_no: "",
        bus_color: "",
        model_number: "",
        vehicle_chasis_number: ""
      }
    },
    assignStaff: {
      assignStaffFormData: {
        bus_id: "",
        driver_id: "",
        driver_no: "",
        driver_licence: "",
        attender_id: "",
        attender_no: ""
      }
    }
  },
  assignStudentData: "",
  newAddStudentList: []
}

const busTrackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE_ADD_ROUTE_FORM':
      return { ...state, isaddRouteFormOpen: action.value }
    case 'HANDLE_EDIT_ROUTE_FORM':
      return { ...state, iseditRouteFormOpen: action.value }
    case 'HANDLE_ADD_STOP_FORM':
      window.localStorage.setItem('menuCollapsed', action.value)
      return { ...state, isaddStopFormOpen: action.value }
    case 'HANDLE_EDIT_STOP_FORM':
      window.localStorage.setItem('menuCollapsed', action.value)
      return { ...state, iseditStopFormOpen: action.value }
    case 'HANDLE_ADD_BUS_FORM':
      return { ...state, isaddBusFormOpen: action.value }
    case 'HANDLE_EDIT_BUS_FORM':
      return { ...state, iseditBusFormOpen: action.value }
    case 'HANDLE_ASSIGN_STAFF_FORM':
      // window.localStorage.setItem('menuCollapsed', action.value)
      return { ...state, isAssignFormOpen: action.value }
    case 'HANDLE_EDIT_ASSIGN_STAFF_FORM':
      // window.localStorage.setItem('menuCollapsed', action.value)
      return { ...state, iseditAssignFormOpen: action.value }
    case "HANDLE_Add_BUS_FORM_DATA":
      if (action.value === "reset") {
        return {
          ...state,
          manageBus: {
            ...state.manageBus,
            addBus: {
              ...state.manageBus.addBus,
              addBusFormData: {
                bus_no: "",
                registration_number: "",
                registration_date: "",
                seating_capacity: "",
                vendor_name: "",
                vendor_phone_no: "",
                bus_color: "",
                model_number: "",
                vehicle_chasis_number: ""
              }
            }
          }
        }
      } else if (action.value.type === "add") {
        return { ...state, manageBus: { ...state.manageBus, addBus: { ...state.manageBus.addBus, addBusFormData: { ...state.manageBus.addBus.addBusFormData, [action.value.name]: action.value.value } } } }
      } else if (action.value.type === "edit") {
        return { ...state, manageBus: { ...state.manageBus, addBus: { ...state.manageBus.addBus, addBusFormData: { ...state.manageBus.addBus.addBusFormData, ...action.value.data } } } }
      }
      break
    case "HANDLE_ASSIGN_STAFF_FORM_DATA":
      if (action.value === "reset") {
        return {
          ...state,
          manageBus: {
            ...state.manageBus,
            assignStaff: {
              ...state.manageBus.assignStaff,
              assignStaffFormData: {
                bus_id: "",
                driver_id: "",
                driver_no: "",
                driver_licence: "",
                attender_id: "",
                attender_name: ""
              }
            }
          }
        }
      } else if (action.value.type === "add") {
        return { ...state, manageBus: { ...state.manageBus, assignStaff: { ...state.manageBus.assignStaff, assignStaffFormData: { ...state.manageBus.assignStaff.assignStaffFormData, [action.value.name]: action.value.value } } } }
      } else if (action.value.type === "edit") {
        return { ...state, manageBus: { ...state.manageBus, assignStaff: { ...state.manageBus.assignStaff, assignStaffFormData: { ...state.manageBus.assignStaff.assignStaffFormData, ...action.value.data } } } }
      }
      break
    case "HANDLE_ADD_ROUTE_FORM_DATA":
      if (action.value === "reset") {
        return {
          ...state,
          routeInfo: {
            ...state.routeInfo,
            addRoute: {
              ...state.routeInfo.addRoute,
              addRouteFormData: {
                bus_id: "",
                route_name: "",
                teacher_id: "",
                teacher_no: "",
                attender_name: "",
                attender_number: "",
                driver_license: "",
                driver_name: "",
                driver_number: ""
              }
            }
          }
        }
      } else if (action.value.type === "add") {
        return { ...state, routeInfo: { ...state.routeInfo, addRoute: { ...state.routeInfo.addRoute, addRouteFormData: { ...state.routeInfo.addRoute.addRouteFormData, [action.value.name]: action.value.value } } } }
      } else if (action.value.type === "edit") {
        return { ...state, routeInfo: { ...state.routeInfo, addRoute: { ...state.routeInfo.addRoute, addRouteFormData: { ...state.routeInfo.addRoute.addRouteFormData, ...action.value.data } } } }
      }
      break
    case "HANDLE_ADD_STOP_FORM_DATA":
      if (action.value.type === "addForm") {
        return { ...state, routeInfo: { ...state.routeInfo, addStop: { ...state.routeInfo.addStop, addStopFormData: [...state.routeInfo.addStop.addStopFormData, { ...action.value.data }] } } }
      } else if (action.value.type === "removeForm") {
        let data = state.routeInfo.addStop.addStopFormData.filter((e, i) => i !== action.value.index)
        data = data.map((io, index) => {
          io["stop_number"] = index + 1
          return io
        })
        return { ...state, routeInfo: { ...state.routeInfo, addStop: { ...state.routeInfo.addStop, addStopFormData: [...data] } } }
      } else if (action.value === "reset") {
        const data = state.routeInfo.addStop.addStopFormData.map(item => {
          item["stop_name"] = ""
          item["pickup_time"] = ""
          item["drop_time"] = ""
          item["distance_from_school"] = ""
          item["lat"] = ""
          item["long"] = ""
          return item
        })
        return {
          ...state, routeInfo: { ...state.routeInfo, addStop: { ...state.routeInfo.addStop, route_id: '', addStopFormData: [...data] } }
        }
      } else if (action.value.type === "add") {
        const { index, name, value } = action.value
        if (name === "route_id") {
          return { ...state, routeInfo: { ...state.routeInfo, addStop: { ...state.routeInfo.addStop, route_id: value } } }
        }
        const stopData = [...state.routeInfo.addStop.addStopFormData]
        stopData[index][name] = value
        return { ...state, routeInfo: { ...state.routeInfo, addStop: { ...state.routeInfo.addStop, addStopFormData: [...stopData] } } }
      } else if (action.value.type === "edit") {
        return { ...state, routeInfo: { ...state.routeInfo, addStop: { ...state.routeInfo.addStop, addStopFormData: [action.value.data] } } }
      }
      break
    case "HANDLE_ASSIGN_STUDENT_ROUTE_DATA":
      return { ...state, assignStudentData: action.value }
      break
    case "HANDLE_ADD_STUDENT_LIST_DATA":
      return { ...state, newAddStudentList: action.value }
      break
    default:
      return state
  }
}

export default busTrackingReducer